import { Component } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription } from "rxjs";
import { LanguageService } from './../../../Services/languageService';
import { mdlPayFortRequestDetailsRes } from "../../../Models/mdlPayFortRequestDetailsRes";
import { mdlPremiumAndVehicleInfoCompRenewalRes } from "../../../Models/mdlPremiumAndVehicleInfoCompRenewalRes";
import { mdlProposalAddCompRenewalRes } from "../../../Models/mdlProposalAddCompRenewalRes";
import { ProposalModel } from "../../../Models/ProposalModel";
import { motorProposalService } from "../../../Services/motorProposalService";



@Component({
    selector: 'PayfortConfirmNew',
    templateUrl: './PayfortConfirmNew.html',
    styleUrls: ['./PayfortConfirmNew.css']
})


export class PayfortConfirmNew {

    public isShowLoading: boolean = false;
    public agreeTerms: boolean = false;
    public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    public LngSubscription: Subscription;
    public Lng: string;
    public PaymentType: string;
    public ProposalNo: string;
    public Insured_Name: string;
    public totalPremium: number;
    public proposalObj: ProposalModel = new ProposalModel();
    public objAddProposalRes: mdlProposalAddCompRenewalRes = new mdlProposalAddCompRenewalRes();
    public objmdlPayFortRequestDetailsRes: mdlPayFortRequestDetailsRes = new mdlPayFortRequestDetailsRes();
    public objPremiumAndVehicleInfoRes: mdlPremiumAndVehicleInfoCompRenewalRes = new mdlPremiumAndVehicleInfoCompRenewalRes();


    constructor(private EncriptService: motorProposalService, private lngService: LanguageService) {

        this.LngSubscription = this.lngService.grtLng().subscribe(lng => {
            this.Lng = lng
        });

        if (sessionStorage.getItem("Language") != null) {
            this.Lng = sessionStorage.getItem("Language");
        }
        else {
            this.Lng = "en";
        }
        //this.proposalObj = JSON.parse(sessionStorage.getItem("paymentObj"));
        if (sessionStorage.getItem("paymentObj") != null) {
            this.proposalObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("paymentObj")));
        }
        if (sessionStorage.getItem("objmdlPayFortRequestDetailsRes") != null) {
            this.objmdlPayFortRequestDetailsRes = JSON.parse(sessionStorage.getItem("objmdlPayFortRequestDetailsRes"));
        }
        //this.objAddProposalRes = JSON.parse(sessionStorage.getItem("objAddProposalRes"));
        if (sessionStorage.getItem("objAddProposalRes") != null) {
            this.objAddProposalRes = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("objAddProposalRes")));
        }
        //this.objPremiumAndVehicleInfoRes = JSON.parse(sessionStorage.getItem("objPremiumAndVehicleInfoRes"));
        if (sessionStorage.getItem("objPremiumAndVehicleInfoRes") != null) {
            this.objPremiumAndVehicleInfoRes = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("objPremiumAndVehicleInfoRes")));
        }
        
        if (this.objPremiumAndVehicleInfoRes == null || this.objAddProposalRes == null) {
            this.ProposalNo = this.proposalObj.ProposalNo;
            this.PaymentType = sessionStorage.getItem("PaymentType");
            this.Insured_Name = this.proposalObj.Name;
            this.totalPremium = this.proposalObj.TotalPremium;
        } else {
            this.ProposalNo = this.objAddProposalRes.PROPOSALNO;
            this.PaymentType = sessionStorage.getItem("PaymentType");
            this.Insured_Name = this.objPremiumAndVehicleInfoRes.POLICY_INFO.Insured_Name;
            this.totalPremium = this.objAddProposalRes.TOTAL_PREMIUM;
        }

    }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/PayfortNew/PayfortConfirmNew/PayfortConfirmNew.ts